import {
    apiRequest,
    templateSuratUpdate,
    templateSuratDetail
} from "../../../../../services/adapters/master/templateSuratService.jsx"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", templateSuratUpdate, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", templateSuratDetail, {
            params: query
        }, true)
    }
}

export default UpdateRepository
